'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable no-restricted-syntax */
/* eslint-disable no-cond-assign */
/* eslint-disable no-continue */
/* eslint-disable consistent-return */

// Crude datetime pattern match.. can't use ISO8601 because service
// is also returning some numeric values, e.g. usage data, as strings
// eslint-disable-next-line no-useless-escape
var pattern = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d{3})?$/;

var convertDateStringsToDates = function convertDateStringsToDates(input) {
  if ((typeof input === 'undefined' ? 'undefined' : _typeof(input)) !== 'object') return input;

  for (var key in input) {
    if (!Object.prototype.hasOwnProperty.call(input, key)) continue;

    var value = input[key];
    var match = void 0;

    if (typeof value === 'string' && (match = value.match(pattern))) {
      // Date string is one day off when converted to date object, below code forces fix
      var d = new Date(match[0]);
      input[key] = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
    } else if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
      convertDateStringsToDates(value);
    }
  }
};

/* @ngInject */

exports.default = function ($httpProvider) {
  $httpProvider.defaults.transformResponse.push(function (response) {
    convertDateStringsToDates(response);
    return response;
  });
};


// WEBPACK FOOTER //
// ./config/http-transform.js